import { useState, useMemo } from "react"
import { Modal } from "components"
import Label from "components/forms/label"
import Input from "components/forms/input"
import { lang } from "config"

import SelectDescription from "components/forms/select-description"
import useBranchRepositories from "repositories/branch"

const Content = ({ data, errors, onSubmit, onRemove }) => {
  const [outlet_id, setOutletId] = useState(data.outlet_id)
  const [only_in_stock, setOnlyInStock] = useState(data.only_in_stock)

  const { data: outletSelection, isLoading: isLoadingOutletSelection } =
    useBranchRepositories({ paginate: false })

  const outletOptions = useMemo(() => outletSelection || [], [outletSelection])

  const handleSubmit = (e) => {
    e.preventDefault()

    const payload = {
      outlet_id,
      // simpan sebagai string agar konsisten dengan query param (lebih aman)
      ...(only_in_stock === true || only_in_stock === "true"
        ? { only_in_stock: "true" }
        : {}),
    }

    onSubmit(
      Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v != null && v !== "")
      )
    )
  }

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <Label htmlFor="outlet_id" value="Outlet" />
          <SelectDescription
            onChange={(value) => setOutletId(value)}
            selection={outletOptions}
            isLoading={isLoadingOutletSelection}
            value={outlet_id}
            keyValue={(value) => value.id}
            title={(value) => value.name}
            description={(value) => value.code || value.id}
            placeholder="Select Outlet"
          />
        </div>

        {/* <div>
          <Label htmlFor="only_in_stock" value="Stock" />
          <div className="flex items-center h-[46px] px-4 border border-neutral-200 bg-white rounded-xl">
            <input
              id="only_in_stock"
              type="checkbox"
              checked={only_in_stock === true || only_in_stock === "true"}
              onChange={(e) => setOnlyInStock(e.target.checked)}
              className="w-4 h-4"
            />
            <span className="ml-2 text-xs text-neutral-700">
              Only show items in stock
            </span>
          </div>
        </div> */}

        {/* Optional: quick search by product id (kalau kamu mau masukin ke filter) */}
        {/* 
        <div className="sm:col-span-2">
          <Label htmlFor="product_unit_id" value="Product Unit ID" />
          <Input
            id="product_unit_id"
            placeholder="PRU_..."
            value={product_unit_id}
            onChange={(e) => setProductUnitId(e.target.value)}
          />
        </div>
        */}
      </div>

      <div className="flex items-center space-x-2 text-xs">
        <button
          type="submit"
          className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
        >
          <span>{lang.filter}</span>
        </button>

        <button
          type="button"
          onClick={onRemove}
          className="items-center px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
        >
          <span>{lang.clear}</span>
        </button>
      </div>
    </form>
  )
}

const Filter = ({ data, errors, onSubmit, onRemove }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const handleSubmit = (value) => {
    closeModal()
    onSubmit(value)
  }

  const handleRemove = () => {
    closeModal()
    onRemove()
  }

  return (
    <>
      <button
        onClick={openModal}
        className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          strokeWidth={1}
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>
        </svg>

        <span>{lang.filter}</span>

        {Object.keys(data || {}).length > 0 && (
          <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-neutral-800">
            {`${Object.keys(data).length}`}
          </span>
        )}
      </button>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${lang.filter} ${lang.data}`}
        content={
          <Content
            errors={errors}
            onSubmit={handleSubmit}
            onRemove={handleRemove}
            data={data || {}}
          />
        }
      />
    </>
  )
}

export default Filter
